import React from "react";
import { format } from "date-fns";
import Icon from "../../fontIcons/icon";

export default function TransactionCard(props) {
  const statusDict = {
    FILLED: "Completed",
    FAILED: "Rejected",
    IN_PROGRESS: "Pending",
    AWAITING_ADMIN_ACTION: "Pending",
    AWAITING_USER_VERIFICATION: "Unverified",
    APPROVED_BY_ADMIN: "Success",
    PROCESSED_BY_ADMIN: "Success",
    REJECTED_BY_ADMIN: "Rejected",
    CANCELLED: "Cancelled",
  };

  function getSideText(side) {
    switch (side) {
      case "BUY":
        return (
          <div className="flex items-center justify-end">
            <span className="text-pb-primary-100 font-bold mr-1">Buy</span>
            <span className="text-gray-800 dark:text-gray-400 text-xs">
              {" "}
              Market
            </span>
          </div>
        );
      case "SELL":
        return (
          <div className="flex items-center justify-end">
            <span className="text-pb-primary-100 font-bold mr-1">Sell</span>
            <span className="text-gray-800 dark:text-gray-400 text-xs">
              {" "}
              Market
            </span>
          </div>
        );
      case "WITHDRAW":
        return (
          <div>
            <span className="text-pb-secondary-100 font-bold">Withdraw</span>
          </div>
        );
      case "DEPOSIT":
        return (
          <div>
            <span className="text-pb-primary-100 font-bold">Deposit</span>
          </div>
        );
    }
  }

  return (
    <div className="bg-gray-300 dark:bg-gray-900 p-5">
      <div className="flex justify-between">
        <div>
          <div className="flex items-center mb-3">
            {props.coin == "INR" ? (
              <Icon icon={"inr"} size={20} className="mr-2"></Icon>
            ) : (
              <img
                src={props.coinIcons?.activeIconUrl}
                height="auto"
                width={30}
                className="mr-2"
                alt={props.coin}
              />
            )}
            {/* <Icon className="mr-2" icon={props.coin.toLowerCase()} size={26} /> */}
            <p className="">{props.coin}</p>{" "}
          </div>
          {props.quantity && (
            <span className="flex items-center mb-2">
              <span className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                Quantity
              </span>{" "}
              <span>{props.quantity}</span>
            </span>
          )}

          {props.price && (
            <span className="flex items-center mb-2">
              <span className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                Price
              </span>{" "}
              <span>₹{props.price}</span>
            </span>
          )}
          {typeof props.tds !== "undefined" && props.tds !== null && (
            <span className="flex items-center mb-2">
              <span className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                TDS
              </span>{" "}
              <span>{props.tds > 0 ? "- " + "₹" + props.tds : props.tds}</span>
            </span>
          )}
          {Boolean(props.totalAmount) && (
            <span className="flex items-center">
              <span className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                Total
              </span>{" "}
              <span>₹{Math.floor(props.totalAmount * 100) / 100}</span>
            </span>
          )}
        </div>
        <div className="flex flex-col justify-between text-right">
          <div className="mb-2">{getSideText(props.side)}</div>
          <div>
            <div className="font-bold mb-2">{statusDict[props.status]}</div>

            <div className="text-gray-800 dark:text-gray-400 text-xs">
              {props.updatedAt
                ? format(
                    new Date(props.updatedAt),
                    "dd.MM.yy, hh:mm:ss aaaaa'm'",
                  )
                : format(new Date(props.createdAt), "dd.MM.yy")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
